<template>
  <div>
    <div class="sr-tag" v-if="!getTextModel">
      <el-tag
        :key="index"
        v-for="(tag, index) in value"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
        >{{ tag }}</el-tag
      >
      <el-popover
        v-model="inputVisible"
        ref="popover"
        popper-class="tag_popover"
        placement="right"
        width="304"
        offset="20"
        trigger="manual"
      >
        <el-table
          @row-click="rowClick"
          :show-header="false"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column :prop="unitName"></el-table-column>
        </el-table>
      </el-popover>
      <el-input
        v-if="inputVisible"
        class="input-new-tag"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        @input="handleInput"
        @keyup.enter.native="handleInputConfirm"
      ></el-input>
      <div class="button-new-tag" @click="showInput" v-else>+ 新增</div>
    </div>
    <div v-else>
      {{ value && value.length > 0 ? value.toString(",") : "" }}
    </div>
  </div>
</template>


<script>
export default {
  name: "SrTag",
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 模糊查询时传递给后端的key，value为输入框中的值
    keyword: {
      type: String,
      default: () => {
        return "keyword";
      },
    },
    // 请求接口查询列表数据
    getList: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          return resolve;
        });
      },
    },
    // 额外的查询参数
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 选中数据之后将数据中的哪个字段回显到tag上
    unitName: {
      type: String,
      default: () => {
        return "unitName";
      },
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      tableData: [],
    };
  },

  methods: {
    // 删除tag
    handleClose(tag) {
      this.value.splice(this.value.indexOf(tag), 1);
    },
    // 显示输入框
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
        console.log("this.getList", this.getList);
        this.getList({ ...this.params }).then((res) => {
          if (res.msg.code === "0000") {
            this.tableData = res.data.records;
          }
        });
      });
    },
    // 输入完成点击enter
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.value.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // 输入过程中进行模糊查询
    handleInput(val) {
      this.getList({
        ...this.params,
        [this.keyword]: val,
      }).then((res) => {
        if (res.msg.code === "0000") {
          this.tableData = res.data.records;
        }
      });
    },
    // 从查询到的列表中点击选择一条数据加入tag
    rowClick(val) {
      this.value.push(val[this.unitName]);
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrTag/index.vue